import { FC, useState } from 'react'

import { Button } from '@/components/Button/Button'
import { LoadableComponent } from '@/components/LoadableComponent'
import { appOpenedSource } from '@/constants/analytics'
import { icons } from '@/constants/icons'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import { deepLinkToAppId } from '@/platform/platform'
import { sendEventToGTAG } from '@/utils/utils'

import { DeepLinkButtonProps } from './types'
import { DeepLinkButtonWrapper } from '../styles'

export const DeepLinkButton: FC<DeepLinkButtonProps> = ({
  deepLinkData,
  categoryId,
}) => {
  const { t } = useCommonTranslation()
  const [isLoading, setIsLoading] = useState(false)

  const onSelectedDeepLink = async (e: LRUDEvent) => {
    e.preventDefault()
    e.stopPropagation()

    if (!deepLinkData?.tizen) {
      return
    }

    try {
      setIsLoading(true)
      deepLinkToAppId(deepLinkData.tizen)
      sendEventToGTAG(appOpenedSource.DEEP_LINK, {
        app_name: deepLinkData?.tizen?.appName,
        category: categoryId,
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <DeepLinkButtonWrapper>
      <LoadableComponent isLoading={isLoading}>
        <Button
          iconSrc={icons.register.loginIcon}
          text={t('watchNow')}
          onClick={onSelectedDeepLink}
        />
      </LoadableComponent>
    </DeepLinkButtonWrapper>
  )
}
